
var content = require("!!../../../../web-builder/node_modules/css-loader/index.js??ref--9-1!../../../../web-builder/node_modules/postcss-loader/src/index.js??ref--9-2!../../../../web-builder/node_modules/sass-loader/lib/loader.js??ref--9-3!./screens.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"singleton":true,"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../web-builder/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../web-builder/node_modules/css-loader/index.js??ref--9-1!../../../../web-builder/node_modules/postcss-loader/src/index.js??ref--9-2!../../../../web-builder/node_modules/sass-loader/lib/loader.js??ref--9-3!./screens.scss", function() {
		var newContent = require("!!../../../../web-builder/node_modules/css-loader/index.js??ref--9-1!../../../../web-builder/node_modules/postcss-loader/src/index.js??ref--9-2!../../../../web-builder/node_modules/sass-loader/lib/loader.js??ref--9-3!./screens.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}